import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

import componentStyles from './pc-chip.css.lit';
import globalStyles from './pc-chip.lightDom.css.lit';

export const chipVariants = [
  'default',
  'link',
  'letter',
  'square-light',
  'square-dark',
] as const;
export type ChipVariant = (typeof chipVariants)[number];

/**
 * Chip component
 * @element pc-chip
 * @slot - This element has a default slot
 */
@customElement('pc-chip')
export class PCChip extends OutlineElement {
  adoptedStylesheets: AdoptedStyleSheets;
  static styles: CSSResultArray = [componentStyles];

  @property({ type: String })
  variant: ChipVariant = 'default';

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
    const classes = ['chip', `chip--${this.variant}`];

    this?.querySelector('a')?.classList.add(...classes);
  }

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-chip': PCChip;
  }
}
